import axios from "axios";
import { WEBSERVICE } from "./CoreDataService";
import { tokenCookie } from "./SystemHandler/AuthRedirectHandler";

/*** Ad Center calls go through the BrokerAdminApi forwarder with the sign-in token ***/
const adCenterApi = axios.create({ baseURL: `${WEBSERVICE}/adCenter` });

adCenterApi.interceptors.request.use((config) => {
  const token = tokenCookie.get() || localStorage.getItem("access_token_us");
  const adminUser = localStorage.getItem("uuid");
  config.headers.authorization = `bearer ${token}`;

  // adminUser must be the signed-in user (it has to match the token)
  if ((config.method || "get").toLowerCase() === "get") {
    config.params = { ...(config.params || {}), adminUser };
  } else if (config.data instanceof FormData) {
    config.data.set("adminUser", adminUser);
  } else if (config.data && typeof config.data === "object") {
    config.data = { ...config.data, adminUser };
  } else if (!config.data) {
    config.data = { adminUser };
  }
  return config;
});

export default adCenterApi;
